import { defineMessage } from 'services/localization';

export const messages = {
    skip: defineMessage('skip_this_step'),
    back: defineMessage('choose_a_different_system_to_connect'),
};
